declare namespace $ {

	type $mol_string__value_shm_hitalama_profile_register_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_register['login'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_profile_register_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_profile_register_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_password__value_shm_hitalama_profile_register_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_register['passwond'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_password__submit_shm_hitalama_profile_register_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_register['submit'] >
		,
		ReturnType< $mol_password['submit'] >
	>
	type $mol_labeler__title_shm_hitalama_profile_register_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_profile_register_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_shm_hitalama_profile_register_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_register['submit_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_profile_register_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_register['submit'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_shm_hitalama_profile_register_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_register['submit_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_text__text_shm_hitalama_profile_register_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_register['message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_hitalama_profile_register extends $mol_section {
		login( next?: string ): string
		Login( ): $mol_string
		Login_label( ): $mol_labeler
		passwond( next?: string ): string
		submit( next?: any ): any
		Password( ): $mol_password
		Password_label( ): $mol_labeler
		submit_title( ): string
		submit_enabled( next?: boolean ): boolean
		Submit( ): $mol_button_major
		message( next?: string ): string
		Message( ): $mol_text
		message_view( ): readonly(any)[]
		title( ): string
		profiles( ): $shm_hitalama_profile_dict
		account_exist_message( ): string
		content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=register.view.tree.d.ts.map